import { booleanAttribute, Component, input } from '@angular/core';
import { CheckboxChangeEvent } from 'primeng/checkbox';
import { InputBase } from '../base/input-base';

@Component({
  selector: 'app-checkbox',
  styleUrl: './checkbox.component.scss',
  template: `
    <div class="inline-flex gap-2">
      <p-checkbox
        name="should_renew"
        id="checkbox"
        [(ngModel)]="value"
        [binary]="true"
        [disabled]="isDisabled()"
        class="flex items-center"
        [value]="value"
        (onFocus)="onTouched()"
        (onBlur)="onTouched()"
        (onChange)="onChangCheckbox($event)"
        [styleClass]="styleClass"
      />
      @if (label()) {
        <label
          for="checkbox"
          class="text-base"
          [ngClass]="{ 'font-semibold': semibold() }"
        >
          {{ label() }}
        </label>
      }
    </div>

    <app-helper-text [errorMessage]="errorMessage" [showErrors]="showErrors" />
  `,
})
export class CheckboxComponent extends InputBase {
  label = input();
  semibold = input(false, { transform: booleanAttribute });

  protected onChangCheckbox(event: CheckboxChangeEvent) {
    this.onChange?.(event.checked);
  }

  get styleClass() {
    return this.showErrors ? 'ng-invalid ng-dirty' : '';
  }

  writeValue(value: boolean): void {
    this.value = value;
  }
}
